import { createApi } from '@reduxjs/toolkit/query/react';
import getAxiosRTKBaseQuery from 'services/api/getAxiosRTKBaseQuery';

export const secureApi = createApi({
  reducerPath: 'secure-api',
  baseQuery: getAxiosRTKBaseQuery({ useAnonymous: false }),
  tagTypes: [
    'User Info',
    'User Settings',
    'Invitation',
    'SharedItem',
    'Pricing Information',
  ],
  endpoints: () => ({}),
});

export const publicApi = createApi({
  reducerPath: 'public-api',
  baseQuery: getAxiosRTKBaseQuery({ useAnonymous: true }),
  tagTypes: ['Mobile Settings'],
  endpoints: () => ({}),
});

export * from './axiosInstance';
